import { MAIN_ROUTE } from "../consts/consts";
import MainPage from '../pages/MainPage'

export const routes = [
  {
    path: MAIN_ROUTE,
    Component: MainPage
  }
]